import React, { useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import {
  Flex,
  TabsContainer,
  Tabs,
  H1WithBack,
  PageWrapper,
  ContentWrapper,
} from 'styling/GlobalStyles'
import { IndustryBasicInfoTab } from './IndustryBasicInfoTab'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { addIndustry } from 'features/industries/industriesSlice'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const AddIndustry = () => {
  const [active, setActive] = useState('Basic Info')
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [state, setState] = useState({
    name: '',
  })

  useFocusFirstInput()

  const handleSubmit = async () => {

    if (state?.name?.length < 1) {
      toast.warn('Name must not be empty')
    } else {
      const resp = await dispatch(addIndustry(state))
      if (resp.meta.requestStatus === 'fulfilled') {
        navigate('/industries')
      }
    }
  }

  const renderTabs = () => {
    if (active === 'Basic Info') {
      return <IndustryBasicInfoTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
  }

  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack mb='1.5' arrow title='Add Industry' />
          <TabsContainer>
            <Tabs active={active === 'Basic Info'} onClick={() => setActive('Basic Info')}>
              Basic Info
            </Tabs>
          </TabsContainer>
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </div>
  )
}
